export default __webpack_public_path__ + "static/media/bghome.d412fbbc.jpg";